var html = document.documentElement;
var body = document.body;

// ================================
// Dark/light mode
// ================================
const toggleLight = document.querySelector('.toggle-light');
const toggleDark = document.querySelector('.toggle-dark');

if (toggleLight) {
  toggleLight.addEventListener('click', () => {
    document.documentElement.classList.remove('dark');
    localStorage.setItem('dark-mode', false);
  })
}

if (toggleDark) {
  toggleDark.addEventListener('click', () => {
    document.documentElement.classList.add('dark');
    localStorage.setItem('dark-mode', true);
  })
}

// ================================
// Infinite Scroll
// ================================
// const nextPage = document.getElementById('next');

// if (nextPage) {
//   var infScroll = new InfiniteScroll('.post-grid', {
//     path: '#next',
//     append: '.post-card',
//     history: false,
//     hideNav: '.pagination'
//   });

//   infScroll.on('append', function(response, path, items) {
//     for (var i = 0; i < items.length; i++) {
//       reloadSrcsetImgs(items[i]);
//     }
//   });

//   function reloadSrcsetImgs(item) {
//     var imgs = item.querySelectorAll('img[srcset]');
//     for (var i = 0; i < imgs.length; i++) {
//       var img = imgs[i];
//       img.outerHTML = img.outerHTML;
//     }
//   }
// }
